import React, { createContext, useContext, useMemo, useState } from "react";

const EqualizedViewContext = createContext<{
  isEqualizedView: boolean;
  setIsEqualizedView: (isEqualizedView: boolean) => void;
}>({
  isEqualizedView: false,
  setIsEqualizedView: () => {},
});

export const useEqualizedView = () => {
  const { isEqualizedView, setIsEqualizedView } =
    useContext(EqualizedViewContext);
  return { isEqualizedView, setIsEqualizedView };
};

export const EqualizedViewContextProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [isEqualizedView, setIsEqualizedView] = useState(false);
  const contextValue = useMemo(
    () => ({ isEqualizedView, setIsEqualizedView }),
    [isEqualizedView, setIsEqualizedView],
  );
  return (
    <EqualizedViewContext.Provider value={contextValue}>
      {children}
    </EqualizedViewContext.Provider>
  );
};
